export default function OfficeHour(props, products) {
  const product = props.product || products.find((product) => product.sku == props.sku)
  const variant = product && product.variants && product.variants[0]

  const self = {
    belongsToOtherShop: (shop_name) => product && product.shop.shopify_domain != shop_name,
    relatesTo: function(sku) {
      const skusRelated = [self.skuSub].concat(self.skus_related || [])
      return skusRelated.map((skuRelated) => skuRelated && skuRelated.toLowerCase()).indexOf(sku && sku.toLowerCase()) != -1
    },
    product: product,
    schedule: props.schedule,
    meeting_link: props.meeting_link,
    skus_related: props.skus_related,
    sku:  props.sku,
    skuSub: props.sku.replace(/_OH/i, '_SUB_FULL'),
    id: props.id,
    password: props.password,
    rsvp_url: props.rsvp_url,
    title: product && product.title || props.sku,
    bodyHtml: product && product.body_html,
    variant: variant,
    price: variant && variant.price,
    variantId: variant && variant.id,
    updated_at: props.updated_at
  }
  return self
}
